import { render, staticRenderFns } from "./BloodTypeForm.vue?vue&type=template&id=289ed3f3&"
import script from "./BloodTypeForm.vue?vue&type=script&lang=js&"
export * from "./BloodTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports